import { render, staticRenderFns } from "./PosArticleListEdit.vue?vue&type=template&id=639786aa&"
import script from "./PosArticleListEdit.vue?vue&type=script&lang=js&"
export * from "./PosArticleListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports